/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import ResizeObserverPolyFill from 'resize-observer-polyfill'

// get native ResizeObserver or Polyfill
const Observer = window.ResizeObserver ? window.ResizeObserver : ResizeObserverPolyFill

/**
 * Create and apply a callback to a resize observer
 * @param {Object} ref - React reference of the node to observe
 * @param {Function} onResize - callback to be executed on resize
 */
export default function useResizeObserver(ref, onResize) {
  // initialize observer
  React.useEffect(() => {
    // create ResizeObserver with given callback
    const observer = new Observer(onResize)

    // observe node
    ref.current && observer.observe(ref.current)

    // provide callback to be called on unmount
    return () => {
      // stop observing the node
      ref.current && observer.unobserve(ref.current)

      // and disconnect the resize observer
      observer.disconnect()
    }
    // update effect when node ref changes
  }, [ref.current])
}
